import { useAppDisplayModeContext } from '@archipro-design/aria';
import type { LoadingValue } from '@archipro-design/aria';

import type { FeaturedSlideProps } from '../../type';

import FeaturedCarouselMobile from './FeaturedCarousel.mobile';
import FeaturedCarouselDesktop from './FeaturedCarousel.deskop';

export interface FeaturedCarouselProps {
    featuredSlides: FeaturedSlideProps[];
    imageLazyLoading?: LoadingValue;
    backgroundColor?: string;
    height?: number | null;
    maskColor?: string;
}

const FeaturedCarousel: React.FC<FeaturedCarouselProps> = ({
    featuredSlides,
    imageLazyLoading = 'lazy',
    backgroundColor = 'transparent',
    height,
    maskColor,
}) => {
    const { mobile: isMobile } = useAppDisplayModeContext();

    return (
        <>
            {isMobile ? (
                <FeaturedCarouselMobile
                    height={height}
                    featuredSlides={featuredSlides}
                    imageLazyLoading={imageLazyLoading}
                    maskColor={maskColor}
                />
            ) : (
                <FeaturedCarouselDesktop
                    featuredSlides={featuredSlides}
                    imageLazyLoading={imageLazyLoading}
                    backgroundColor={backgroundColor}
                    maskColor={maskColor}
                />
            )}
        </>
    );
};

export default FeaturedCarousel;
